/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { StateOSD } from '../../../widgets/state-osd-v2-widget-react';
import { HtmlPage } from '../../../widgets/landing-page-widget';
import {
  VerifyProductPageService,
  BadgeDetailPageService,
} from '../../../services';
import { VApplication } from '../../../application';
import { useTheme } from '../../../providers/theme';
import {
  useSMVerifyProductPage,
  useSMVerifyProductPageContent,
} from '../machines';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import './custom.css';
import { Form, Footer } from '../components';
import ContactFrom from '../components/ContactForm';
import validate from '../components/ContactForm/validationRules';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import footerConfig from '../../../services/VerifyProductPageService/config/footer.config.json';
import ReactRecaptcha3 from 'react-google-recaptcha3';
import { DEFAULT_APP_CONFIG as config } from '../../../config/default.config';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.VerifyProductPageService'
  ) as VerifyProductPageService;
};

const getBadgeSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.BadgeDetailPageService'
  ) as BadgeDetailPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const srv = getSrv();
  const badgeSrv = getBadgeSrv()?.getPageContent();
  console.log(`badgeSrv :`, badgeSrv);
  const { width, height, bp } = useViewport();
  const staticPageContentConfig = srv?.getStaticPageContent();
  const [buttonItem, setButtonItem] = useState();
  const history = useHistory();
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [spinner, setspinner] = useState(false);
  const [shouldSubmit, setShouldSubmit] = useState(false);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
  });

  console.log(`values in ContainerCOm: `, values);

  const {
    verifyProductPageState,
    verifyProductPageMachine,
    verifyProductPageSend,
  } = useSMVerifyProductPage({});

  const { verifyProductContentPageState } = useSMVerifyProductPageContent({});

  useEffect(() => {
    ReactRecaptcha3.init(config.CAPTCHA_SITE_KEY).then((status: any) => {
      console.log(status);
    });
    // async function getNavItems() {
    //   let _navlinks = await srv?.getHeaderNavItems();
    //   console.log(`nav items`, _navlinks);
    //   if (_navlinks) {
    //     setButtonItem(_navlinks);
    //   }
    // }
    // setTimeout(() => {
    //   getNavItems();
    // }, 500);
  }, []);

  useEffect(() => {
    console.log(`on location useEffect`);
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then(function (result) {
          if (result.state === 'granted') {
            console.log('bla 1 : ', result.state);
            navigator.geolocation.getCurrentPosition(success, locationError, {
              enableHighAccuracy: true,
            });
            //If granted then you can directly call your function here
          } else if (result.state === 'prompt') {
            console.log('bla 2 : ', result.state);
            navigator.geolocation.getCurrentPosition(success, locationError, {
              enableHighAccuracy: true,
            });
          } else if (result.state === 'denied') {
            console.log('bla 4 : ', result.state);
            //If denied then you have to show instructions to enable location
          }
          result.onchange = function () {
            console.log('bla 3 : ', result.state);
          };
        });
    } else {
    }
  });

  useEffect(() => {
    if (
      verifyProductPageState?.matches('RENDER_PAGE') &&
      verifyProductPageState?.event?.data?.value
    ) {
      let _data = verifyProductPageState?.event?.data?.value;
      console.log(`_data?.scannedHashCount :`, _data?.scannedHashCount, _data);
      _acceptedTos(verifyProductPageState?.event?.data?.value);

      if (_data?.isAuthentic) {
        let _image: string = '';
        if (
          verifyProductPageState?.event?.data?.value &&
          verifyProductPageState?.event?.data?.value?.product?.images
        ) {
          let _images =
            verifyProductPageState?.event?.data?.value?.product?.images;
          _image =
            _images && Array.isArray(_images) && _images.length > 0
              ? _images[0]
              : null;
        }
        console.log(`_image:`, _image);
        history.push('/verify-success', { image: _image });
      } else {
        let _image: string = '';
        if (
          verifyProductPageState?.event?.data?.value &&
          verifyProductPageState?.event?.data?.value?.product?.images
        ) {
          let _images =
            verifyProductPageState?.event?.data?.value?.product?.images;
          _image =
            _images && Array.isArray(_images) && _images.length > 0
              ? _images[0]
              : null;
        }
        history.push('/verify-failure', { image: _image });
      }
    }
  }, [
    verifyProductPageState?.matches('RENDER_PAGE') &&
      verifyProductPageState?.event?.data?.value,
  ]);

  function success(pos: any) {
    var crd = pos?.coords;

    console.log('bla Your current position is:');
    console.log(`bla Latitude : ${crd.latitude}`);
    console.log(`bla Longitude: ${crd.longitude}`);
    console.log(`bla More or less ${crd.accuracy} meters.`);

    // getFullProvSev()?.setLocationData({
    //   latitude: crd?.latitude,
    //   longitude: crd?.longitude
    // })
    if (!location?.latitude || !location?.longitude) {
      console.log('location Data: ', location, crd?.latitude);
      const _location = {
        latitude: crd?.latitude,
        longitude: crd?.longitude,
      };
      setLocation(_location);
    }
  }

  function locationError(err: any) {
    console.warn(`bla ERROR(${err.code}): ${err.message}`);
  }

  console.log('verifyProductPageState', location, verifyProductPageState);
  const _data = {
    title: 'Welcome to the Trag Product Authentication Page',
    subject: 'NFT Enquiry',
    text: 'For all queries, Please email us using this form',
    // url: DEFAULT_APP_CONFIG?.organization?.contactUs,
    // appId:DEFAULT_APP_CONFIG?.organization?.appId,
    action: 'query_request',
    id: 'contact',
  };

  const onSkipClick = () => {
    const _errors = validate(values);
    console.log(`onSkipClick error: `, _errors);
    if (_errors?.disclaimer) {
      setErrors({ disclaimer: _errors?.disclaimer });
    } else if (!_errors?.disclaimer) {
      setShouldSubmit(false);
      verifyProductPageSend('START', {
        payload: { ...location, skipped: true },
      });
    }
  };

  const handleSubmit = (event: any) => {
    console.log('handleSubmit', event);
    const _errors = validate(values);
    event.preventDefault();
    setErrors(_errors);
    // Your url for API
    //  const url = "";
    console.log(`handleSubmit #2 ->`, Object.keys(values).length);
    const _values = { ...values, ...location };
    if (
      values &&
      _errors &&
      Object.entries(_errors) &&
      Object.entries(_errors).length === 0
    ) {
      setShouldSubmit(false);
      verifyProductPageSend('START', { payload: { ..._values } });
    }
  };

  const handleChange = (event) => {
    console.log(
      `on Change: `,
      event?.target?.name,
      event?.target?.value,
      event,
      values
    );
    let _values = values;
    if (event?.target?.name === 'disclaimer' && values?.disclaimer === 'on') {
      _values =
        _values &&
        Object.fromEntries(
          Object.entries(_values).filter((e) => e[0] != 'disclaimer')
        );
    } else {
      _values = {
        ..._values,
        [event.target.name]: event.target.value,
      };
    }
    console.log(`on Change #1 :`, _values);
    event.persist();
    setValues(_values);
    setErrors((errors) => ({ ...errors, [event.target.name]: '' }));
  };

  const onGenderSelect = (event: any) => {
    console.log(`on gender change:`, event);
    event.persist();
    setValues((values) => ({
      ...values,
      ['gender']: event?.target?.id,
    }));
    setErrors((errors) => ({ ...errors, ['gender']: '' }));
  };

  const _acceptedTos = async (data: any) => {
    console.log(`testing #1 :`, values);
    const gtin = data?.product?.gtin;
    const temrs_privacy = [
      'https://vlinder.io/terms',
      'https://vlinder.io/privacy',
    ];
    if (gtin) {
      try {
        temrs_privacy.map(async (item) => {
          const res = await getSrv()?.tosProduct({
            gtin: gtin,
            action: 'customer_tac',
            service_agreement: item,
            isAgeConfirmed: true,
          });
          return res;
        });
        ReactRecaptcha3.getToken().then(
          async (token) => {
            console.log(`recaptchatoken :`, token);
            let _callFeedback: any;
            if (data?.skipped) {
              _callFeedback = await srv?.onFeedbackSubmit({
                variables: {
                  appMode: 'web',
                  scanType: 'qrcode',
                  gtin: gtin,
                  batchNo: data?.product?.batch,
                  lat: location?.latitude ? location?.latitude.toString() : '',
                  lon: location?.longitude
                    ? location?.longitude.toString()
                    : '',
                  scanCount: data?.scannedHashCount
                    ? data?.scannedHashCount.toString()
                    : '',
                  scanLogId: data?.scanLogId,
                  recaptchatoken: token,
                },
              });
            } else {
              _callFeedback = await srv?.onFeedbackSubmit({
                variables: {
                  appMode: 'web',
                  scanType: 'qrcode',
                  gtin: gtin,
                  batchNo: data?.product?.batch,
                  lat: location?.latitude ? location?.latitude.toString() : '',
                  lon: location?.longitude
                    ? location?.longitude.toString()
                    : '',
                  phone: values ? values?.phone : '',
                  userName: values ? values?.name : '',
                  email: values ? values?.email : '',
                  scanCount: data?.scannedHashCount
                    ? data?.scannedHashCount.toString()
                    : '',
                  scanLogId: data?.scanLogId,
                  recaptchatoken: token,
                },
              });
            }
            console.log(`testing _callFeedback #2 :`, _callFeedback);
          },
          (error) => {
            console.log(`error`);
          }
        );
      } catch (err: any) {}
    }
  };

  if (verifyProductPageState?.matches('GET_PAGE_CONTENT')) {
    return (
      <StateOSD
        backgroundImage={staticPageContentConfig?.backgroundImage}
        {...(staticPageContentConfig?.loading?.pageLoading || {})}
      />
    );
  }

  if (verifyProductPageState?.matches('RENDER_PAGE_ERROR')) {
    history.push('/verify-invalid');
  }

  return (
    <>
      <div className='bubbleC' />
      <div className='bottomBubbleC' />
      <div className='bottomRectangleC' />
      <div className='containerC' />
      <div className='headerLogoContainerC'>
        <Image
          src={'https://i.ibb.co/8dmDZGB/trag-text-logo.png'}
          width={'30%'}
        />
      </div>
      <div
        className='MainContainer'
        style={{
          display: '-webkit-flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: height - 64.75,
          // backgroundImage: `url(${staticPageContentConfig?.backgroundImage})`,
          // backgroundSize: 'cover',
        }}
      >
        {/* <Form
          LAYOUT={staticPageContentConfig?.LAYOUT}
          FIELDS={staticPageContentConfig?.FIELDS}
        /> */}
        <ContactFrom
          {..._data}
          illustation={staticPageContentConfig?.illustation}
          color={'#984f24'}
          handleChange={handleChange}
          errors={errors}
          values={values}
          shouldSubmit={shouldSubmit}
          spinner={spinner}
          handleSubmit={handleSubmit}
          onGenderSelect={onGenderSelect}
          onSkipClick={onSkipClick}
        />
      </div>
      <Footer {...footerConfig} />
    </>
  );
};
